<template>
    <div
        class="p-4 border border-gray-200 dark:border-gray-700 rounded-lg"
        :class="getNotificationStyle(notification.type)"
    >
        <div class="flex items-start">
            <div class="shrink-0">
                <Icon :type="getIcon(notification.type)" :class="getIconColor(notification.type)" class="text-xl" />
            </div>

            <div class="ml-4 flex-auto">
                <p class="text-sm text-gray-600 dark:text-gray-400">
                    {{ notification.message || 'No description available' }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardMessageBellNotification',
    props: {
        notification: {
            type: Object,
            required: true,
        },
    },

    methods: {
        getIcon(type) {
            return 'bell';
        },

        getIconColor(type) {
            return 'text-gray-500';
        },
        getNotificationStyle(type) {
            return 'border-l-4 border-primary-500 bg-primary-50 dark:bg-primary-900';
        },
    },
};
</script>
